import * as Icons from "lucide-react";

export function I({ name, className }) {
  const Cmp = Icons[name] || Icons.Sparkles;
  return <Cmp className={className} />;
}

export function SectionHeading({ eyebrow, title }) {
  return (
    <div className="max-w-[60ch]">
      <p className="eyebrow mb-4">{eyebrow}</p>
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.08]">{title}</h2>
    </div>
  );
}

export function slugify(s) {
  return String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
}
